/**
 * Dismiss-Utilities fuer StatusBanner (W0.6)
 *
 * Hash-Funktion: erste 20 Zeichen der Message + simpler 32-bit-Stringhash
 * → verschiedene Messages erzeugen verschiedene localStorage-Keys
 */

export function simpleHash(str: string): string {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i)
    hash |= 0 // 32-bit integer
  }
  return Math.abs(hash).toString(36)
}

export function dismissKey(message: string): string {
  const prefix = message.slice(0, 20)
  return `ht-status-dismissed-${prefix}-${simpleHash(message)}`
}

export function isDismissed(message: string): boolean {
  try {
    return localStorage.getItem(dismissKey(message)) === '1'
  } catch {
    return false
  }
}

export function setDismissed(message: string): void {
  try {
    localStorage.setItem(dismissKey(message), '1')
  } catch {
    // localStorage nicht verfuegbar — kein Crash
  }
}
